import Middleware from '../middleware/editable';
import Popper from 'popper.js';
import Job from './bulk-processor';
import { Format } from 'admin-columns-js/helper/strings';
import BulkEditRow from "./bulk-edit-row";
import Notice from './bulk-notice';
var i18n = {
    UPDATE: Format(ACP_Editing.i18n.bulk_edit.form.update_values, '<span data-acp-be-count>0</span>'),
    ARE_YOU_SURE: ACP_Editing.i18n.bulk_edit.form.are_you_sure,
    YES_UPDATE: ACP_Editing.i18n.bulk_edit.form.yes_update,
    CANCEL: ACP_Editing.i18n.cancel
};
var defaults = {
    total_count: ACP_Editing.bulk_edit.total_items
};
var BulkEdit = /** @class */ (function () {
    function BulkEdit(Table, Editables) {
        this.Table = Table;
        this.Editables = Editables;
        this.Middleware = new Middleware(this.Editables);
        this.Notice = new Notice(this.Table);
        this.EditableModal = false;
        this.EditRow = new BulkEditRow(this);
        this._allSelected = false;
        this._isConfirmed = false;
        this.init();
    }
    BulkEdit.prototype.init = function () {
        this.addTableEvents();
    };
    BulkEdit.prototype.setConfirmed = function (confirm) {
        this._isConfirmed = confirm;
        return this;
    };
    BulkEdit.prototype.isConfirmed = function () {
        if (ACP_Editing.bulk_edit.hasOwnProperty('show_confirmation') && !ACP_Editing.bulk_edit.show_confirmation) {
            return true;
        }
        return this._isConfirmed;
    };
    BulkEdit.prototype.onSave = function (editable, cell) {
        var _this = this;
        if (!this.isConfirmed()) {
            this.confirm(editable);
            return;
        }
        var job = new Job(cell.column, editable.getValue(), this.getItemsToProcess(), this._allSelected);
        this._locked = true;
        this.EditableModal.setProcess(job.getElement());
        this.Editable.disable();
        editable.getElement().querySelector('.aceditable__form__controls [data-submit]').style.display = 'none';
        // Bind Events
        job.Events.addListener('close', function () {
            _this.EditableModal.close();
        });
        job.Events.addListener('finished', function () {
            AdminColumns.Editing.TableUpdate.updateSelectedCells(cell.column.name, editable.getValue());
            if (_this.EditableModal) {
                _this.EditableModal.setCanDismiss(true);
                _this.EditableModal.toggleCloseButton(true);
            }
        });
    };
    BulkEdit.prototype.onButtonTrigger = function (cell) {
        var _this = this;
        var middleware = this.Middleware.get(cell.column);
        var editable = middleware.getEditable();
        var modal = AdminColumns.Editing.BulkEdit.Modal;
        this.setConfirmed(false);
        if (!editable || this.EditableModal) {
            return false;
        }
        var editableArgs = middleware.getArgs();
        editableArgs.showbuttons = true;
        editableArgs.mode = 'bulk';
        var Editable = new editable(editableArgs);
        var EditableModal = new modal(modal.appendMarkup(), Editable);
        Editable.getEditableTemplate().setSubmitButton('Update');
        EditableModal.setTitle("Bulk Edit \u201C" + cell.column.label + "\u201D");
        EditableModal.setTotal(this.getSelectedCount());
        EditableModal.open();
        this.EditableModal = EditableModal;
        this.Editable = Editable;
        this.updateCount();
        // Bind Events
        Editable.Events.addListener('save', function (editable) {
            _this.onSave(editable, cell);
        });
        EditableModal.Events.addListener('close', function () {
            _this.destroyEditable();
            _this.EditableModal = null;
        });
    };
    BulkEdit.prototype.destroyEditable = function () {
        this.removeConfirm();
        this.Editable.close();
        this.EditableModal.destroy();
    };
    BulkEdit.prototype.confirm = function (editable) {
        var _this = this;
        this.removeConfirm();
        var confirm = document.createElement('div');
        confirm.classList.add('acp-be-confirm');
        confirm.innerHTML = "\n\t\t\t<span class=\"acp-be-confirm__caret\"></span>\n\t\t\t<em class=\"acp-be-confirm__info\">" + i18n.UPDATE + "</em>\n\t\t\t<div class=\"acp-be-confirm__controls\"><strong>" + i18n.ARE_YOU_SURE + "</strong> <a data-confirm class=\"acp-be-confirm__controls__link -confirm\">" + i18n.YES_UPDATE + "</a> <a data-cancel class=\"acp-be-confirm__controls__link -cancel\">" + i18n.CANCEL + "</a></div>\n\t\t";
        document.body.append(confirm);
        new Popper(editable.getEditableTemplate().el.querySelector('[data-submit]'), confirm, {
            modifiers: {
                preventOverflow: { enabled: false },
                hide: { enabled: false },
                arrow: { element: '.acp-be-confirm__caret' }
            }
        });
        this._confirmElement = confirm;
        this.setConfirmed(false);
        this.updateCount();
        // Bind Events
        var elDialog = this.EditableModal.el.querySelector('.ac-modal__dialog');
        var elConfirm = confirm.querySelector('[data-confirm]');
        var elCancel = confirm.querySelector('[data-cancel]');
        elDialog.addEventListener('keypress', function (e) {
            if (e.key === 'Enter' && document.querySelectorAll('.acp-be-confirm').length > 0) {
                _this.setConfirmed(true);
                _this.removeConfirm();
                editable.save();
            }
        });
        elConfirm.addEventListener('click', function () {
            _this.setConfirmed(true);
            _this.removeConfirm();
            editable.save();
        });
        elCancel.addEventListener('click', function () {
            _this.setConfirmed(false);
            _this.removeConfirm();
        });
    };
    BulkEdit.prototype.addTableEvents = function () {
        var _this = this;
        var checkboxes = this.Table.el.querySelectorAll('.check-column input[type=checkbox]');
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                _this._allSelected = false;
                setTimeout(function () {
                    if (_this.Table.Selection.getCount() > 1) {
                        _this.toggleEditRows(true);
                    }
                    else {
                        _this.toggleEditRows(false);
                    }
                    if (_this.Table.Selection.isAllSelected() && (defaults.total_count && _this.Table.Selection.getCount() < defaults.total_count)) {
                        var link_1 = _this.Notice.createSelectAll(defaults.total_count);
                        defaults.total_count = defaults.total_count ? defaults.total_count : 'all';
                        if (link_1) {
                            link_1.style.display = 'inline';
                            link_1.addEventListener('click', function () {
                                link_1.style.display = 'none';
                                _this._allSelected = true;
                                _this.updateCount();
                            });
                        }
                    }
                    _this.updateCount();
                });
            });
        });
        this.Table.el.addEventListener('scroll', function (e) {
            var table = AdminColumns.Table.el;
            var notice = table.querySelector('.acp-be-noticerow .acp-be-notice p');
            if (!notice) {
                return;
            }
            if (document.body.classList.contains('acp-overflow-table')) {
                notice.style.left = table.scrollLeft + "px";
            }
            else {
                notice.style.left = 0;
            }
        });
    };
    BulkEdit.prototype.toggleEditRows = function (show) {
        if (show === void 0) { show = true; }
        this.Notice.removeNotice();
        this.EditRow.remove();
        if (show) {
            this.Notice.addNotice();
            this.EditRow.add();
        }
    };
    BulkEdit.prototype.getSelectedCount = function () {
        var count = this.Table.Selection.getCount();
        if (this._allSelected) {
            count = defaults.total_count;
        }
        return count;
    };
    BulkEdit.prototype.updateCount = function () {
        var _this = this;
        document.querySelectorAll('[data-acp-be-count]').forEach(function (el) {
            el.innerHTML = _this.getSelectedCount();
        });
    };
    BulkEdit.prototype.getItemsToProcess = function () {
        if (this._allSelected) {
            return defaults.total_count;
        }
        return this.Table.Selection.getIDs();
    };
    BulkEdit.prototype.removeConfirm = function () {
        if (!this._confirmElement) {
            return;
        }
        this._confirmElement.remove();
    };
    return BulkEdit;
}());
export default BulkEdit;
